const Button = ({
    id,
    label,
    disabled,
    loading,
    onClick,
    containerClass,
    type,
    notUseLoadingAnimation,
    ...other
}) => {
    return (
        <div className={`form-group ${containerClass || ''}`}>
            <button id={id} onClick={onClick} disabled={(loading || disabled)}
                className={`btn ${type} ${(loading || disabled) ? 'disabled' : ""}`}
                {...other}
            >
                {
                    !notUseLoadingAnimation && loading ?
                        <div className="btn-loading-container">
                            <div className="bar"></div>
                            <div className="bar"></div>
                            <div className="bar"></div>
                            <div className="bar"></div>
                        </div>
                        :
                        label
                }
            </button>
        </div>
    )
}
export default Button
